import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import { useState, useEffect, Fragment } from "react";

import CampaignStatus from "../Status";
import FormOne from "./CreateCampaignFirstForm";
import FormTwo from "./CreateCampaignSecondForm";
import FormThird from "./CreateCampaignThirdForm";
import CampaignLiveUser from "../CampaignLiveUser";
import FormFifth from "./CreateCampaignFifthForm";
import ExploreConnection from "../ExploreConnection";
import FormSeventh from "./PreferredCampaignChannel";
import UploadCSV from "../../uploadCSV dailog/UploadCSV";
import AdminCampaignStatus from "../AdminCampaignStatus";
import CampaignButtons from "./../CreateCampaignButtons";
import ShowAudienceSizeDialog from "../ShowAudienceSize";
import EditButtons from "../../../../components/EditButtons";
import TakeUpDialog from "../../take up offer components/TakeUpDailog";
import { ButtonFooter, PageHeader, Paper } from "../../../../components";
import RejectOfferDialog from "../../reject offer components/RejectOfferDialog";
import BrandDetailsDialog from "../../brand details components/BrandDetailsDialog";
import Connections from "../../superadmin campaign details component/ConnectionList";
import BroadcastReportDialog from "../../broadcast report dialog component/BroadcastReportDialog";
import pages from "../../../../constants/pages";

export default function FormDisplay({
  agentToken,
  setAgentToken,
  audiences,
  editState,
  liveUsers,
  categories,
  rejectOffer,
  formikProps,
  takeUpOffer,
  audienceData,
  setEditState,
  audienceSize,
  component = "",
  brandDetails,
  setTakeUpOffer,
  setBrandDetails,
  connectionList,
  setRejectOffer,
  setAudienceData,
  setAudienceCreated,
  preferredChannels,
}) {
  const [tabValue, setTabValue] = useState("Campaign");
  const [brandIdentity, setBrandIdentity] = useState(false);
  const [dialogUploadCSV, setDialogUploadCSV] = useState(false);
  const [broadcastReportDialog, setBroadcastReportDialog] = useState(false);
  const { activeBrand } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    if (formikProps.values.brandID) {
      if (parseInt(formikProps.values.brandID) !== parseInt(activeBrand.ID)) {
        setBrandIdentity(true);
      }
    }
  }, [formikProps.values.brandID, activeBrand.ID]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PageHeader
          pageName={"Campaigns"}
          pageHeader={
            !formikProps.values.campaignID ? "New Campaign" : "View Campaign"
          }
          buttons={[
            tabValue === "Campaign" &&
              formikProps.values?.campaignIsEditable && (
                <EditButtons
                  path={pages.myCampaign.route}
                  formikProps={formikProps}
                  editState={editState}
                  setEditState={setEditState}
                />
              ),

            <CampaignButtons
              editState={editState}
              setAudienceData={setAudienceData}
              ID={formikProps.values.campaignID}
              liveUsers={liveUsers}
              setEditState={setEditState}
              formikProps={formikProps}
              component={component}
              brandIdentity={brandIdentity}
              setTakeUpOffer={setTakeUpOffer}
              setDialogUploadCSV={setDialogUploadCSV}
              setBroadcastReportDialog={setBroadcastReportDialog}
            />,
          ]}
        />
      </Grid>

      {component !== "" && (
        <Grid item xs={12}>
          <CampaignStatus
            formikProps={formikProps}
            setTakeUpOffer={setTakeUpOffer}
          />
        </Grid>
      )}

      {component === "" &&
        formikProps.values.campaignID &&
        tabValue === "Campaign" && (
          <Grid item xs={12}>
            <AdminCampaignStatus
              audienceSize={audienceSize}
              formikProps={formikProps}
            />
          </Grid>
        )}

      {tabValue === "Campaign" &&
        component === "" &&
        formikProps.values.permissionSettings?.connection_list && (
          <Connections connections={connectionList} formikProps={formikProps} />
        )}

      {!formikProps.values.campaignID && preferredChannels.length === 0 && (
        <Grid item xs={12}>
          <Paper>
            <Grid item xs={12}>
              <Typography>
                Please add channel first to create campaigns
              </Typography>
            </Grid>
          </Paper>
        </Grid>
      )}

      {tabValue === "Campaign" && (
        <Grid item xs={12}>
          <Paper gridSpacing={6}>
            <FormOne
              categories={categories}
              brandDetails={brandDetails}
              setBrandDetails={setBrandDetails}
              formikProps={formikProps}
              editState={editState}
              component={component}
              brandIdentity={brandIdentity}
            />
          </Paper>

          <Paper gridSpacing={6}>
            <FormTwo
              setAudienceData={setAudienceData}
              formikProps={formikProps}
              audiences={audiences}
              editState={editState}
              component={component}
              brandIdentity={brandIdentity}
              audienceData={audienceData}
              setAudienceCreated={setAudienceCreated}
            />
          </Paper>

          <Paper gridSpacing={6}>
            <FormThird
              brandIdentity={brandIdentity}
              formikProps={formikProps}
              editState={editState}
              component={component}
            />
          </Paper>

          {component !== "request" && (
            <Paper gridSpacing={6}>
              <FormSeventh
                agentToken={agentToken}
                setAgentToken={setAgentToken}
                editState={editState}
                formikProps={formikProps}
                preferredChannels={preferredChannels}
              />
            </Paper>
          )}

          {editState && (
            <Grid item xs={12}>
              <ButtonFooter
                path={pages.myCampaign.route}
                ID={formikProps.values.campaignID}
                editState={editState}
                setEditState={setEditState}
                formikProps={formikProps}
              />
            </Grid>
          )}

          {formikProps.values.campaignID && (
            <Fragment>
              <Grid item xs={7}>
                {component !== "request" &&
                  component !== "accepted" &&
                  formikProps.values.permissionSettings?.explore_connection && (
                    <ExploreConnection formikProps={formikProps} />
                  )}
              </Grid>
            </Fragment>
          )}

          {!!(audienceSize?.audience_params || audienceSize?.audience_size) && (
            <ShowAudienceSizeDialog audienceSize={audienceSize} />
          )}

          {brandIdentity && (
            <CampaignLiveUser
              takeUpOffer={takeUpOffer}
              liveUsers={liveUsers}
              component={component}
            />
          )}
        </Grid>
      )}

      {formikProps.values.campaignID && tabValue !== "Campaign" && (
        <Grid item xs={12}>
          <Paper gridSpacing={6}>
            <FormFifth
              formikProps={formikProps}
              editState={editState}
              component={component}
              brandIdentity={brandIdentity}
            />
          </Paper>
        </Grid>
      )}

      <RejectOfferDialog reject={rejectOffer} setReject={setRejectOffer} />

      <TakeUpDialog
        takeUp={takeUpOffer}
        formikProps={formikProps}
        setTakeUp={setTakeUpOffer}
      />

      <BrandDetailsDialog details={brandDetails} setDetails={setBrandDetails} />

      <UploadCSV
        dialogUploadCSV={dialogUploadCSV}
        setDialogUploadCSV={setDialogUploadCSV}
        formikProps={formikProps}
      />

      <BroadcastReportDialog
        broadcastReportDialog={broadcastReportDialog}
        setBroadcastReportDialog={setBroadcastReportDialog}
      />
    </Grid>
  );
}
